/**
 * PinnedPreviewPanel — Feb 2026 · Iter88
 *
 * Persistent right-side panel on Stage 9 (Reports & Downloads) that
 * shows up to two pinned artefacts side-by-side. Powered by
 * ArtifactPreviewCard so the render stays consistent with the hover
 * popover.
 */
import { PushPinSlash, X } from "@phosphor-icons/react";
import ArtifactPreviewCard from "./ArtifactPreviewCard";

export default function PinnedPreviewPanel({ pinned, onUnpin, onClose }) {
  if (!pinned?.length) return null;
  return (
    <aside className="w-[360px] shrink-0 h-full border-l border-slate-200
                       bg-white flex flex-col overflow-hidden"
                data-testid="pinned-preview-panel">
      <header className="shrink-0 flex items-center gap-2 px-4 py-2 border-b border-slate-100">
        <span className="text-[10.5px] uppercase tracking-widest text-slate-500 font-mono">
          Compare · {pinned.length}/2
        </span>
        <button
          type="button"
          onClick={onClose}
          data-testid="pinned-preview-close"
          className="ml-auto text-slate-500 hover:text-brand-blue"
          title="Close compare panel"
        >
          <X size={13} weight="bold" />
        </button>
      </header>
      <div className="flex-1 min-h-0 overflow-y-auto px-3 py-3 space-y-3">
        {pinned.map((p, i) => (
          <div key={p.id}
                className="rounded-md border border-slate-200 p-3 relative"
                data-testid={`pinned-preview-slot-${i}`}>
            <button
              type="button"
              onClick={() => onUnpin(p.id)}
              data-testid={`pinned-preview-unpin-${i}`}
              className="absolute top-1 right-1 text-slate-400 hover:text-rose-600 p-0.5"
              title="Unpin"
            >
              <PushPinSlash size={12} />
            </button>
            <ArtifactPreviewCard preview={p.preview} />
          </div>
        ))}
        {pinned.length < 2 && (
          <div className="rounded-md border border-dashed border-slate-300 p-4 text-center
                              text-[10.5px] text-slate-500"
                    data-testid="pinned-preview-empty-slot">
            Pin one more artefact to compare side-by-side
          </div>
        )}
      </div>
    </aside>
  );
}
